// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css } from '@emotion/react';
import { N800 } from '@atlaskit/theme/colors';
import { getTruncateStyles } from '../../../../utils';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var dropdownItemGroupStyles = css({
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
  button: {
    width: '220px',
    '&:hover': {
      backgroundColor: 'inherit',
      cursor: 'default'
    }
  }
});
var sharedBlockStyles = css({
  display: 'flex',
  gap: "var(--ds-space-100, 0.5rem)",
  // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
  lineHeight: '1rem',
  minWidth: 0,
  overflow: 'hidden',
  flexDirection: 'row',
  alignItems: 'center'
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
export var contentStyles = css(sharedBlockStyles, {
  marginTop: "var(--ds-space-025, 2px)",
  alignItems: 'flex-start',
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
  '> span, > div': {
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    color: "var(--ds-text, ".concat(N800, ")")
  }
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
export var linkStyles = css(sharedBlockStyles, {
  cursor: 'pointer',
  font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
  marginTop: "var(--ds-space-100, 8px)",
  marginLeft: "var(--ds-space-400, 32px)",
  marginBottom: "var(--ds-space-025, 2px)"
});
export var textStyles = function textStyles(maxLines) {
  return css({
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '1rem',
    whiteSpace: 'normal'
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
  getTruncateStyles(maxLines));
};